import React from 'react';
import { Row, Col} from "react-bootstrap";

const LinkCreatedDialog = () => {
  
return (
    <Row
        className="justify-content-center mt-4"
      >
        <Col xs={12} md={6}>
          <div className="p-4 border rounded shadow-sm text-center">
            <div
              className="mb-3"
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                backgroundColor: "#fcefa1",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 auto",
              }}
            >
              🎉 {/* Replace with your success icon/image */}
             </div>
            <h5>Your link has been created</h5>
            <p className="mt-2 text-muted">Navigate to the Dashboard to view your link.</p>
          </div>
        </Col> 
      </Row>
);
};

export default LinkCreatedDialog;
